<script>
export default {
    name: 'IconPlus',
}
</script>
<template lang="pug">
svg(aria-hidden='true' role='img' xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewbox='0 0 20 20')
    path(transform='translate(20 17.5)' fill='currentColor' d='M-10-15.625a8.125,8.125,0,0,1,7.036,4.063,8.125,8.125,0,0,1,0,8.125A8.125,8.125,0,0,1-10,.625a8.125,8.125,0,0,1-7.036-4.062,8.125,8.125,0,0,1,0-8.125A8.125,8.125,0,0,1-10-15.625ZM-10,2.5a10,10,0,0,0,8.66-5,10,10,0,0,0,0-10,10,10,0,0,0-8.66-5,10,10,0,0,0-8.66,5,10,10,0,0,0,0,10A10,10,0,0,0-10,2.5Zm-.937-6.562A.935.935,0,0,0-10-3.125a.935.935,0,0,0,.938-.937v-2.5h2.5A.935.935,0,0,0-5.625-7.5a.935.935,0,0,0-.937-.937h-2.5v-2.5A.935.935,0,0,0-10-11.875a.935.935,0,0,0-.937.938v2.5h-2.5a.935.935,0,0,0-.937.938.935.935,0,0,0,.938.938h2.5Z')
</template>
